import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { ArrowLeft, BarChart3, Users, BookOpen, Sparkles, LogOut, Wand2 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const tabs = [
  { to: "/admin", label: "Overview", icon: BarChart3, end: true, testid: "admin-tab-overview" },
  { to: "/admin/users", label: "Users & Orders", icon: Users, testid: "admin-tab-users" },
  { to: "/admin/prompts", label: "Prompts", icon: Wand2, testid: "admin-tab-prompts" },
  { to: "/admin/resources", label: "Resources", icon: BookOpen, testid: "admin-tab-resources" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col">
      <header className="bg-[#1A1F3D] text-white">
        <div className="container-bsp h-16 flex items-center justify-between gap-4">
          <Link to="/admin" className="flex items-center gap-2" data-testid="admin-logo">
            <div className="w-8 h-8 rounded-md bg-[#D4A853] flex items-center justify-center">
              <Sparkles className="w-4 h-4 text-[#1A1F3D]" />
            </div>
            <span className="font-display text-xl">BrandSnapPro™</span>
            <span className="ml-2 text-[10px] uppercase tracking-[0.2em] font-semibold text-[#D4A853] border border-[#D4A853]/40 px-2 py-0.5 rounded">Admin</span>
          </Link>
          <div className="flex items-center gap-4 text-sm">
            <Link to="/app" className="text-white/80 hover:text-white inline-flex items-center gap-1.5" data-testid="back-to-app">
              <ArrowLeft className="w-4 h-4" /> Back to app
            </Link>
            <span className="hidden sm:inline text-white/50">·</span>
            <span className="hidden sm:inline text-white/70 truncate max-w-[180px]">{user?.email}</span>
            <button onClick={onLogout} className="text-white/70 hover:text-white inline-flex items-center gap-1.5" data-testid="admin-logout">
              <LogOut className="w-4 h-4" /> Log out
            </button>
          </div>
        </div>
        <nav className="container-bsp flex gap-1 overflow-x-auto scrollbar-clean">
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={t.testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                  isActive ? "border-[#D4A853] text-[#D4A853]" : "border-transparent text-white/70 hover:text-white"
                }`
              }
            >
              <t.icon className="w-4 h-4" /> {t.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="flex-1 container-bsp py-10">
        <Outlet />
      </main>
    </div>
  );
}
